function isTestEnvironment() {
    return import.meta.env['NODE_ENV'] === 'test'
}

interface LogType {
    type: 'error' | 'debug'
    args: any[]
}

const backlog: LogType[] = []
function lazyInit() {
    if ((global as any).testBacklog !== backlog) {
        ;(global as any).testBacklog = backlog
    }
}

function logError(...args: any[]): void {
    lazyInit()
    if (isTestEnvironment()) {
        backlog.push({type: 'error', args})
        return
    }

    console.error(...args)
}

function logDebug(...args: any[]): void {
    lazyInit()
    if (isTestEnvironment()) {
        backlog.push({type: 'debug', args})
        return
    }

    console.log(...args)
}

export {logError, logDebug, backlog}
